import React, { useState, useCallback, useContext, useEffect, useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import ModalComponent from 'molecules/Modal';
import ScheduleOrderFormSection from 'organisms/ScheduleOrder/Presentation/ScheduleOrderFormSection';
import DateTimeSection from 'organisms/ScheduleOrder/Presentation/DateTimeSection';
import { formatDateTime, getCurrentDateTimeInUnix, getEpochTime, getFormatFromUnix } from 'common/utilities/dayJsUtils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  createBasketData,
  createPayloadForStatusCall,
  getAndCheck,
  getDeliveryAddressData,
  getDispositionTypeOnAPIFormat,
  getTernaryValue,
  getValueOrDefaultObject,
  isEmptyEvery,
  ParseJsonSafely,
  isCateringDisposition,
  getFullAddressDetails,
  getToday,
  isFutureTime,
  isFutureDate,
  isAsapOrder,
  isDeliveryDisposition,
  recursiveOrCheck,
} from 'common/utilities/utils';

import { UserOrderContext } from 'context/context';
import {
  LOCAL_STORAGE_KEYS,
  DISPOSITION_KEYS,
  SESSION_STORAGE_KEYS,
  ROUTE_URL,
  SPACE_REGEX,
  DATE_FORMATS,
  ASAP,
  SHUTDOWNS,
} from 'common/constants/SharedConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';
import { FORM, searchStoreConfig, STORES } from 'organisms/SearchStore/AU/Config/searchStore.config';
import { deliveryAddressSearchFormConfig } from 'organisms/DeliveryAddressSearchForm/Config/deliveryAddressSearchForm.config';
import { useDispatch, useSelector } from 'react-redux';
import { createBasketsAction, updateStoreWithDisposition } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { useHistory } from 'react-router-dom';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import {
  getBulkStoreStatus,
  getStoreOrderCapacityAction,
  getStoreStatusForTimeSaga,
  orderReadyDateTimeUpdate,
} from '@kfc-global/react-shared/redux/Actions/StoresAction';
import {
  getDispositionObj,
  getStoreUnavailableErrorAnalytic,
  setScheduleDataOnChangeFlow,
  dateTimeManipulation,
  successCallbackHandler,
  changedDeliveryAddress,
  scheduledTimeError,
  scheduledOrderCapacityTimeSlotError,
  getDateAndSelectedTime,
  storeOrderSchedulingUnavailable,
  scheduledOrderCapacityNoOrdersError,
} from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { ButtonType, ContainedButton } from '../../../../atoms/Buttons';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { resetMenuFulfillmentData } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import { changeOrderAnalyticsHandler } from '../../../StartOrderComponent/StartOrderUtilities/startOderUtils';
import ImageComponent from '../../../../atoms/Image';
import { useAppSelector } from '@kfc-global/react-shared/redux/Store/hooks';
import { getPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';
import { selctedAddressCheck } from 'organisms/SearchStore/AU/SearchStoreUtilities/SearchStoreUtils';

export const scheduleTimeErrorFlag = (selectedTime, enableScheduleOrderFlag) =>
  selectedTime?.key < getCurrentDateTimeInUnix() && enableScheduleOrderFlag;
export const disableDateOption = (enableScheduleOrderFlag, dateTimeArr) =>
  enableScheduleOrderFlag ? dateTimeArr?.length <= 1 : false;
export const disableTimeOption = (enableScheduleOrderFlag, selectedDate, orderCapacityError) =>
  enableScheduleOrderFlag ? !selectedDate?.timeSlots?.length || orderCapacityError : false;
export const showChangeCTAForDelivery = (disableChangeCTAForDelivery, dispositionType, isFromDeliveryAddressForm) => {
  return !(disableChangeCTAForDelivery && isDeliveryDisposition(dispositionType)) && !isFromDeliveryAddressForm;
};
export const inactivateStartOrderButton = ({
  storeUnavailableError,
  enableScheduleOrderFlag,
  selectedTime,
  showOrderNow,
  changeScheduleMode,
  hasError,
  isForNow,
  scheduleModeClicked,
}) =>
  Boolean(storeUnavailableError) ||
  hasError.error ||
  disableStartOrder(
    enableScheduleOrderFlag,
    selectedTime,
    showOrderNow,
    changeScheduleMode,
    isForNow,
    scheduleModeClicked,
  );
export const getScheduledEpochDateTime = (isASAPOrder, selectedTime) => {
  return !isASAPOrder && !isEmpty(selectedTime) ? selectedTime.key : '';
};
export const enableScheduleMode = (
  setOrderNowFlag,
  setScheduleOrdeFlag,
  setScheduleDisposition,
  setChangeScheduleOrderMode,
  userOrderStateDispatch,
) => {
  setOrderNowFlag(false);
  setScheduleOrdeFlag(true);
  setScheduleDisposition(true);
  setChangeScheduleOrderMode(true);
  if (userOrderStateDispatch) {
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.SHOW_SCHEDULE_DISPOSITION,
      value: { showSheduleDisposition: true },
    });
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.ORDER_CAPACITY_DATA_UPDATED,
      value: { orderCapacityDataUpdated: false },
    });
  }
};
export const changeTimeValue = (selectedItem, setSelectedTime = null, setErrorObj = {}) => {
  const { setHasError, hasError } = setErrorObj;
  setSelectedTime(selectedItem);
  scheduledTimeError(setHasError, hasError, false);
  scheduledOrderCapacityTimeSlotError(setHasError, hasError, false);
};
export const changeDateValue = (
  selectedItem,
  dateTimeArr,
  setSelectedDate,
  setSelectedTime,
  setErrorObj,
  dispositionType,
  changeDateObj = {},
) => {
  const { setHasError, hasError } = setErrorObj;
  const { userOrderStateDispatch, orderCapacityDataUpdated = '', setOrderCapacityCallDispatched } = changeDateObj;
  scheduledTimeError(setHasError, hasError, false);
  scheduledOrderCapacityNoOrdersError(setHasError, hasError, false);
  const filteredDateObj = dateTimeArr?.find(item => item?.date?.key === selectedItem?.key);
  setSelectedDate(filteredDateObj);
  if (dispositionType?.toUpperCase() === DISPOSITION_KEYS.CHRISTMAS_ORDERING) {
    setSelectedTime(translateWithI18Next(TRANSLATE_MAPPING_KEY.SELECT_PICKUP_TIME));
  } else {
    setSelectedTime({ ...filteredDateObj?.timeSlots?.[0] });
  }
  setOrderCapacityCallDispatched && setOrderCapacityCallDispatched(false);
  userOrderStateDispatch &&
    userOrderStateDispatch({ type: orderCapacityDataUpdated, value: { orderCapacityDataUpdated: false } });
};

export const getBasket = (event, response, disbaleScheduleWarning, createBasket) => {
  if (
    response?.[0]?.summary?.status?.currentStatus === SEARCH_STORE_CONSTANTS.STORE_STATUS_OPEN ||
    disbaleScheduleWarning
  ) {
    createBasket(event, response[0], localStorage.getItem(LOCAL_STORAGE_KEYS.SET_CART_CLEAR));
  }
};

export const disableStartOrder = (
  enableScheduleOrderFlag,
  selectedTime,
  showOrderNow,
  changeScheduleMode,
  isForNow,
  scheduleModeClicked,
) => {
  if (
    enableScheduleOrderFlag &&
    isEmpty(selectedTime) &&
    !changeScheduleMode &&
    (!showOrderNow || !isForNow) &&
    scheduleModeClicked
  ) {
    return true;
  }
  return false;
};
export const getContent = (changeScheduleMode, service) => {
  const selectedTimeText =
    service?.toUpperCase() === DISPOSITION_KEYS.DELIVERY
      ? translateWithI18Next(TRANSLATE_MAPPING_KEY.SELECT_DELIVERY_TIME)
      : translateWithI18Next(TRANSLATE_MAPPING_KEY.SELECT_PICKUP_TIME);
  return changeScheduleMode ? selectedTimeText : translateWithI18Next(TRANSLATE_MAPPING_KEY.ASAP);
};

export const getDisableWarning = (enableScheduleOrderFlag, showScheduleOrder) =>
  enableScheduleOrderFlag && showScheduleOrder;
export const getDateString = dispositionNew => {
  if (dispositionNew !== null) {
    const { date = '', store: selectedStore = {}, time = '' } = dispositionNew;
    const { MMMM_D } = DATE_FORMATS;
    let updatedTime = time?.replace(SPACE_REGEX, '')?.toLowerCase();
    const dateArray = time !== ASAP && formatDateTime(date, MMMM_D)?.split(' ');
    return time === ASAP
      ? translateWithI18Next(TRANSLATE_MAPPING_KEY.ASAP)
      : `${translateWithI18Next(getToday(date, selectedStore?.summary?.timeZoneIANA))} ${
          translateWithI18Next(dateArray[0]) + ' ' + dateArray[1]
        }, ${updatedTime}`;
  }
  return '';
};

export const checkForDate = ({
  isForNow = false,
  enableScheduleOrderFlag,
  showScheduleOrder,
  showSheduleDisposition,
  shouldShowDateTime,
}) => {
  return enableScheduleOrderFlag ? (showScheduleOrder || isForNow) && !showSheduleDisposition : shouldShowDateTime;
};

export const checkforTime = (changeFlow, isAddressFlow, dispositionType) => {
  return getDispositionObj(changeFlow, isAddressFlow, dispositionType)?.dispositionValue === DISPOSITION_KEYS.PICKUP
    ? translateWithI18Next(TRANSLATE_MAPPING_KEY.PICK_UP_TIME)
    : translateWithI18Next(TRANSLATE_MAPPING_KEY.DELIVERY_TIME);
};
export const isFutureDateOrderHandler = (currentStoreInfoData, isStoreOrderSchedulingUnavailable) =>
  Boolean(isFutureTime(currentStoreInfoData) || isFutureDate(currentStoreInfoData)) &&
  !isStoreOrderSchedulingUnavailable;
export const isAsapSelecetedUnavailable = (selectedStoreStatus, isAsapOrderFlag, selectedTime) =>
  Boolean(
    (selectedStoreStatus?.currentStatus !== SEARCH_STORE_CONSTANTS.STORE_STATUS_OPEN || !isAsapOrderFlag) &&
      selectedTime?.key === ASAP,
  );
export const isFutureTimeSelectedUnavailable = (
  isFutureTimeDateOrder,
  selectedDate,
  selectedTime,
  enableOrderCapacityManagement,
) =>
  Boolean(
    (isFutureTimeDateOrder && !selectedDate?.timeSlots?.length) ||
      (selectedTime?.key !== ASAP && !isFutureTimeDateOrder && !enableOrderCapacityManagement),
  );
export const checkDateandTime = ({
  enableScheduleOrderFlag,
  showScheduleOrder,
  scheduleOrderFlag,
  showSheduleDisposition,
  shouldShowDateTime,
}) => {
  return enableScheduleOrderFlag
    ? (showScheduleOrder || scheduleOrderFlag) && showSheduleDisposition
    : shouldShowDateTime;
};
export const isStoreCompletelyClosed = ({
  enableScheduleOrderFlag,
  isAsapSelecetedUnavailableFlag,
  isFutureTimeSelectedUnavailableFlag,
  isStoreStatusLoading,
  selectedStoreStatus,
  currentStoreInfoData,
}) => {
  const { STORE_STATUS_OPEN } = SEARCH_STORE_CONSTANTS;
  return enableScheduleOrderFlag
    ? (isAsapSelecetedUnavailableFlag ||
        isFutureTimeSelectedUnavailableFlag ||
        !SHUTDOWNS.includes(selectedStoreStatus?.message?.split('||')[0]?.trim())) &&
        !isStoreStatusLoading &&
        Boolean(selectedStoreStatus?.currentStatus !== STORE_STATUS_OPEN && !isStoreStatusLoading)
    : Boolean(selectedStoreStatus?.currentStatus !== STORE_STATUS_OPEN && !isStoreStatusLoading);
};
export const checkDateString = (enableScheduleOrderFlag, dispositionNew) =>
  enableScheduleOrderFlag && getDateString(dispositionNew);

export const checkCardData = (userOrderState, userOrderStateDispatch) =>
  userOrderState.findAKFC &&
  userOrderStateDispatch({ type: START_ORDER_CONSTANTS.SEARCH_ORDER_DATA, value: { showSearchStore: true } });
export const showOrderNowFlag = (changeScheduleOrderMode, orderNowFlag, showOrderNowMode) =>
  changeScheduleOrderMode ? orderNowFlag : showOrderNowMode;
export const showScheduleOrderFlag = (changeScheduleOrderMode, scheduleOrderFlag, showScheduleOrderMode) =>
  changeScheduleOrderMode ? scheduleOrderFlag : showScheduleOrderMode;
export const showChangeScheduleModeFlag = (changeScheduleOrderMode, changeScheduleModeFlag) =>
  changeScheduleOrderMode ? changeScheduleOrderMode : changeScheduleModeFlag;
export const showSheduleDispositionFlag = (scheduleDisposition, scheduleDispositionFlag) =>
  scheduleDisposition ? scheduleDisposition : scheduleDispositionFlag;
export const showHandleBackFlag = (userOrderState, userOrderStateDispatch) =>
  userOrderState.findAKFC &&
  userOrderStateDispatch({ type: START_ORDER_CONSTANTS.ORDER_SUMMARY_MODAL_CLOSE, orderSummaryModalClose: false });
export const getOrderType = props => {
  const {
    enableScheduleOrderFlag,
    showScheduleOrder,
    showSheduleDisposition,
    shouldShowDateTime,
    dateString,
    enableSceduleCA,
    setOrderNowFlag,
    setScheduleOrdeFlag,
    setScheduleDisposition,
    setChangeScheduleOrderMode,
    userOrderState,
    isForNow,
    isSpecialEvent,
    isFromDeliveryAddressForm,
    shouldShowDateTimeSection,
  } = props;
  const { dispositionStateData, scheduleOrderData } = userOrderState;
  const { changeFlow = false, isAddressFlow = false } = scheduleOrderData;
  const { dispositionType } = dispositionStateData;
  return (
    <>
      {!isSpecialEvent && !isFromDeliveryAddressForm && enableScheduleOrderFlag && (
        <ScheduleOrderFormSection
          show={
            !shouldShowDateTimeSection &&
            checkForDate({
              isForNow,
              enableScheduleOrderFlag,
              showScheduleOrder,
              showSheduleDisposition,
              shouldShowDateTime,
            })
          }
          sectionHeader={checkforTime(changeFlow, isAddressFlow, dispositionType)}
          subSectionValue={dateString}
          orderTypeChange={TRANSLATE_MAPPING_KEY.ORDER_TYPE_CHANGE}
          onClickHandler={() =>
            enableScheduleMode(setOrderNowFlag, setScheduleOrdeFlag, setScheduleDisposition, setChangeScheduleOrderMode)
          }
          showChangeButton={enableSceduleCA}
        />
      )}
    </>
  );
};
export const placeholderContentText = (currentStoreInfoData, changeScheduleMode, selectedTimeText) =>
  isFutureTime(currentStoreInfoData) && changeScheduleMode
    ? translateWithI18Next(TRANSLATE_MAPPING_KEY.ASAP)
    : selectedTimeText;

const ScheduleOrderContainer = props => {
  const { Error_Yellow } = IMAGE_PATH;
  const { DELIVERY, CATERING, CHRISTMAS_ORDERING } = DISPOSITION_KEYS;
  const {
    DISPOSITION_TYPE,
    DISPOSITION_NEW,
    DROPOFF_ADDRESS,
    CURRENT_STORE_INFO_STORAGE,
    STORE_INFO,
    CONFIG_SEARCH_SCREEN,
    RENDER_COMP,
    SET_CART_CLEAR,
    CHANGE_SCHEDULE_MODE,
  } = LOCAL_STORAGE_KEYS;
  const {
    ORDER_TYPE,
    YOUR_KFC_RESTAURANT,
    ORDER_TYPE_CHANGE,
    YOUR_LOCATION,
    SCHEDULE_FOR_YOUR_ORDER_TEXT,
    CATERING_WARNING,
    PICK_UP_TIME,
    DELIVERY_TIME,
  } = TRANSLATE_MAPPING_KEY;
  const {
    SEARCH_ORDER_DATA,
    SCHEDULE_ORDER_DATA,
    DISPOSITION_DATA,
    DISPOSITION_METHOD,
    CURRENT_STORE_INFO,
    START_ORDER_CLICK,
    RESET_DELIVERY_ADDRESS_LINE,
    SET_FIND_A_KFC_VIEW,
    SET_REDIRECTION_PATH,
    SET_ASAP_SCHEDULING,
    ORDER_CAPACITY_DATA_UPDATED,
    ORDER_SUMMARY_MODAL_CLOSE,
    SHOW_SCHEDULE_DISPOSITION,
  } = START_ORDER_CONSTANTS;
  const { onStoreSelectFinish } = props;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const {
    dispositionStateData,
    scheduleOrderData,
    searchStoreData,
    redirectionOrder,
    showScheduleOrder: showScheduleOrderMode,
    showOrderNow: showOrderNowMode,
    changeScheduleModeFlag,
    showSheduleDisposition: scheduleDispositionFlag,
    scheduleModeClicked = false,
  } = userOrderState;
  const { configSearchScreen = localStorage?.getItem(CONFIG_SEARCH_SCREEN) } = searchStoreData;
  const { changeFlow = false, isAddressFlow = false } = scheduleOrderData;
  const { dispositionType } = dispositionStateData;
  const getPwaStorageData = useAppSelector(getPWAstorage);
  const dispositionNew = getTernaryValue(
    isEmptyEvery(userOrderState.dispositionNew),
    JSON.parse(localStorage.getItem(DISPOSITION_NEW)),
    userOrderState.dispositionNew,
  );
  const {
    componentOptions,
    enableAddressLocalisation = false,
    enableOrderCapacityManagement = false,
    orderServDateFormat,
    tenantId,
  } = useSelector(state => state?.tenantReducer);
  const { web = {} } = componentOptions;
  const { shouldCheckDropOffAddress = false } = web;
  const dispositionConfig = componentOptions?.web?.dispositionConfig;
  const { enableScheduleOrder = false, enableClickCollectScheduleOrder = false } = dispositionConfig;
  const scheduledDelivery = componentOptions?.web?.scheduledDelivery;
  const { allowScheduleOrderForDispositions = [] } = scheduledDelivery;
  const disableChangeCTAForDelivery = componentOptions?.web?.dispositionConfig?.disableChangeCTAForDelivery;
  const formattedDeliveryAddressFilterBy = web?.global?.formattedDeliveryAddressFilterBy;
  const userParams = useSelector(state => state?.appStateReducer?.userStatus);
  const { id: basketId = '', foodLines = [] } = useSelector(state => state?.cartReducer?.cartData) ?? {};
  const dispatch = useDispatch();
  const history = useHistory();
  const isDelivery = dispositionType?.toUpperCase() === DELIVERY;
  const isFromDeliveryAddressForm = enableAddressLocalisation && isDelivery;
  const cartData = useSelector(state => state?.cartReducer?.cartData);
  const isForNow = cartData?.requestedDateTime?.isForNow;
  const {
    isOrderCapacityLoading,
    isOrderCapacitySuccess,
    isOrderCapacityFailure,
    isStoreStatusLoading,
    orderCapacity,
    storesWithStatus,
  } = useSelector(data => getValueOrDefaultObject(data.storesReducer));
  const [orderNowFlag, setOrderNowFlag] = useState(true);
  const [scheduleOrderFlag, setScheduleOrdeFlag] = useState(false);
  const [changeScheduleOrderMode, setChangeScheduleOrderMode] = useState(false);
  const [scheduleDisposition, setScheduleDisposition] = useState(false);
  const [selectedTime, setSelectedTime] = useState({});
  const [inlineMessage] = useState();
  const [dateTimeArr, setDateTimeArr] = useState([]);
  const [selectedDate, setSelectedDate] = useState({});
  const [getDeliveryAddr, setDeliveryAddr] = useState();
  const [storeUnavailableAnalyticFlag, setStoreUnavailableAnalyticFlag] = useState(false);
  const [orderCapacityActionError, setOrderCapacityActionError] = useState(false);
  const [shouldShowDateTimeSection, setShouldShowDateTimeSection] = useState(false);
  const [orderCapacityCallDispatched, setOrderCapacityCallDispatched] = useState(false);
  const [hasError, setHasError] = useState({
    error: false,
    errormessage: '',
    errorType: '',
    warningMessage: '',
  });
  const showOrderNow = showOrderNowFlag(changeScheduleOrderMode, orderNowFlag, showOrderNowMode);
  const showScheduleOrder = showScheduleOrderFlag(changeScheduleOrderMode, scheduleOrderFlag, showScheduleOrderMode);
  const changeScheduleMode = showChangeScheduleModeFlag(changeScheduleOrderMode, changeScheduleModeFlag);
  const showSheduleDisposition = showSheduleDispositionFlag(scheduleDisposition, scheduleDispositionFlag);
  const setErrorObj = {
    hasError,
    setHasError,
  };
  const isSpecialEvent = dispositionType?.toUpperCase() === CHRISTMAS_ORDERING;
  const currentStoreInfoData = useMemo(() => {
    return getTernaryValue(
      isEmptyEvery(userOrderState.currentStoreInfo),
      ParseJsonSafely(localStorage.getItem(CURRENT_STORE_INFO_STORAGE)),
      userOrderState.currentStoreInfo,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userOrderState.currentStoreInfo]);
  const selectedStoreStatus = storesWithStatus?.[0]?.summary?.status || currentStoreInfoData?.summary?.status;
  const enableClickCollectScheduleOrderFlag =
    enableClickCollectScheduleOrder && allowScheduleOrderForDispositions?.includes(currentStoreInfoData?.service);
  const enableScheduleOrderFlag = enableScheduleOrder || enableClickCollectScheduleOrderFlag;
  const isStoreOrderSchedulingUnavailable = storeOrderSchedulingUnavailable(
    currentStoreInfoData,
    enableScheduleOrderFlag,
    enableClickCollectScheduleOrderFlag,
    false,
  );
  const isFutureTimeDateOrder = isFutureDateOrderHandler(currentStoreInfoData, isStoreOrderSchedulingUnavailable);
  const enableSceduleCA = enableScheduleOrderFlag && (isFutureTimeDateOrder || enableOrderCapacityManagement);
  const dateString = checkDateString(enableScheduleOrderFlag, dispositionNew);
  const orderCapacityDateError =
    enableOrderCapacityManagement &&
    hasError?.error &&
    hasError?.errorType === START_ORDER_CONSTANTS.ORDER_CAPACITY_DAY_ERROR;
  const disableDateOptionFlag = disableDateOption(enableScheduleOrderFlag, dateTimeArr);
  const disableTimeOptionFlag = disableTimeOption(enableScheduleOrderFlag, selectedDate, orderCapacityDateError);
  const displayStoreInfo = currentStoreInfoData;
  const storeId = displayStoreInfo?.id || displayStoreInfo?.storeID;
  const storeName = displayStoreInfo?.name?.[0]?.value || displayStoreInfo?.summary?.name;
  const isAsapOrderFlag = isAsapOrder(currentStoreInfoData);

  /* choose where user needs to be redirected on click of change link from Order Mode screen */
  const onChangeLinkNavigation = useCallback(
    chooseConfig => {
      let searchedLocations = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.SEARCHED_LOCATIONS));
      let recentLocation = !isAddressFlow && searchedLocations ? searchedLocations[searchedLocations?.length - 1] : [];
      changedDeliveryAddress(
        isAddressFlow,
        scheduleOrderData?.storeInfo,
        chooseConfig,
        changeFlow,
        searchedLocations,
        recentLocation,
        userOrderStateDispatch,
      );
    },
    [changeFlow, isAddressFlow, scheduleOrderData?.storeInfo, userOrderStateDispatch],
  );

  const onChangeDisposition = useCallback(() => {
    userOrderStateDispatch({
      type: RESET_DELIVERY_ADDRESS_LINE,
    });
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
    userOrderStateDispatch({ type: SCHEDULE_ORDER_DATA, value: { showScheduleOrderCatering: false } });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    userOrderStateDispatch({ type: ORDER_CAPACITY_DATA_UPDATED, value: { orderCapacityDataUpdated: false } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userOrderStateDispatch]);

  const handleGoBack = useCallback(() => {
    onChangeLinkNavigation(isFromDeliveryAddressForm ? FORM : STORES);
    showHandleBackFlag(userOrderState, userOrderStateDispatch);
    userOrderStateDispatch({ type: ORDER_CAPACITY_DATA_UPDATED, value: { orderCapacityDataUpdated: false } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChangeLinkNavigation]);

  const clearFlag = () => {
    localStorage.removeItem(SET_CART_CLEAR);
  };

  const handleClose = event => {
    clearFlag();
    if (isFromDeliveryAddressForm) {
      userOrderStateDispatch({ type: SCHEDULE_ORDER_DATA, value: { selectedAddress: {} } });
    }
    userOrderStateDispatch({
      type: RESET_DELIVERY_ADDRESS_LINE,
    });
    event.stopPropagation();
    event.preventDefault();
    localStorage.setItem(RENDER_COMP, true);
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: {
        selectedStoreInfo: userOrderState.scheduleOrderData.storeInfo,
        showScheduleOrderCatering: false,
      },
    });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    userOrderStateDispatch({ type: SET_REDIRECTION_PATH, value: { redirectionOrder: '' } });
    userOrderStateDispatch({
      type: SET_FIND_A_KFC_VIEW,
      value: { findAKFC: window.location.pathname === ROUTE_URL.FIND_STORE },
    });
    checkCardData(userOrderState, userOrderStateDispatch);
    userOrderStateDispatch({ type: ORDER_SUMMARY_MODAL_CLOSE, orderSummaryModalClose: false });
    userOrderStateDispatch({ type: ORDER_CAPACITY_DATA_UPDATED, value: { orderCapacityDataUpdated: false } });
  };

  /* return unit number based on different conditions */
  const checkDeliveryAddressLine = getTernaryValue(
    changeFlow,
    getPwaStorageData?.selectedLineValueAddress ??
      ParseJsonSafely(localStorage.getItem(DISPOSITION_NEW))?.deliveryAddressLine,
    getPwaStorageData?.selectedLineValueAddress ?? scheduleOrderData?.deliveryAddressLine,
  );
  const checkSpecialNote = scheduleOrderData?.selectedAddress?.specialNote || '';

  useEffect(() => {
    const getUpdatedAddress = async () => {
      if (isFromDeliveryAddressForm) {
        const formatAddr = ParseJsonSafely(localStorage.getItem(DROPOFF_ADDRESS));
        setDeliveryAddr(formatAddr);
      } else {
        const getDispositionType = dispositionType || DISPOSITION_KEYS.DELIVERY;
        const updatedAddress = await getDeliveryAddressData(
          getDispositionType,
          scheduleOrderData?.deliveryAddress,
          formattedDeliveryAddressFilterBy,
        );
        const formatAddr = getFullAddressDetails(updatedAddress);
        setDeliveryAddr(selctedAddressCheck(getPwaStorageData) ?? formatAddr); // set addr in order mode screen
        localStorage.setItem(LOCAL_STORAGE_KEYS.FORMATTED_DELIVERY_ADDRESS_FILTERBY, formattedDeliveryAddressFilterBy);
      }
    };
    getUpdatedAddress();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleOrderData?.deliveryAddress]);
  const getUserAddress = getTernaryValue(
    changeFlow,
    selctedAddressCheck(getPwaStorageData) ?? ParseJsonSafely(localStorage.getItem(DISPOSITION_NEW))?.deliveryAddress,
    getDeliveryAddr,
  );
  const configSearchKey = `${
    getDispositionObj(changeFlow, isAddressFlow, dispositionType)?.dispositionValue
  }_${configSearchScreen}`;
  const scheduleOrderStartConfig = isFromDeliveryAddressForm ? deliveryAddressSearchFormConfig : searchStoreConfig;
  const {
    shouldShowUserLocation,
    shouldShowOrderType,
    orderModeScreenErrorText,
    scheduleOrderScreenTitle,
    shouldShowDateTime,
    orderModeBtnText,
  } = {
    ...scheduleOrderStartConfig?.[configSearchKey],
    ...dispositionConfig?.[configSearchKey],
  };

  const setDispositionInfo = (selectedDispositionValue, dateTimeObj, obj, updatedBasketId) => {
    const params = {
      dispatch,
      userOrderStateDispatch,
      dispositionNew,
      selectedDispositionValue,
      currentStoreInfoData,
      dateTimeObj,
      scheduleOrderData,
      history,
      redirectionOrder,
      userParams,
      dispositionType,
      fromflag: '',
      obj,
      updatedBasketId,
    };
    if (dateTimeObj.selectedTime !== ASAP && dateTimeObj.time !== ASAP) {
      const { storeId: store_id, channel, service, requestedDateTime } = obj;
      const payload = {
        storeid: store_id,
        channel,
        service,
        futureDateTimeInEpochFormat: requestedDateTime?.futureDateTime,
      };
      dispatch(
        getStoreStatusForTimeSaga({ data: payload, tenantId: tenantId }, () => successCallbackHandler(params), null),
      );
    } else {
      resetMenuFulfillmentData();
      successCallbackHandler(params);
    }
  };

  const clearcartItem = (selectedDispositionValue, dateTimeObj, obj) => {
    clearFlag();
    dispatch(createBasketsAction({ data: obj, tenantId: tenantId }));
    setDispositionInfo(selectedDispositionValue, dateTimeObj, obj, basketId);
  };
  const createBasket = async (event, selectedStoreInfo, isCartNeedToCleared) => {
    userOrderStateDispatch({ type: CHANGE_SCHEDULE_MODE, value: { changeScheduleModeFlag: false } });
    event.stopPropagation();
    event.preventDefault();
    const getDateAndSelectedTimeObj = getDateAndSelectedTime(selectedDate, selectedTime);
    const dateTimeObj = {
      date: getDateAndSelectedTimeObj?.date,
      time: getDateAndSelectedTimeObj?.time,
      selectedTime: getDateAndSelectedTimeObj?.selectedTime,
    };
    const selectedDispositionValue = getDispositionObj(changeFlow, isAddressFlow, dispositionType)?.dispositionValue;
    const payload = {
      storeID: selectedStoreInfo?.id || selectedStoreInfo?.storeId,
      disposition: selectedDispositionValue,
      postCode: selectedStoreInfo?.addresses[0]?.address?.pinCode,
    };
    onStoreSelectFinish(payload);
    userOrderStateDispatch({ type: START_ORDER_CLICK, value: { startOrderBtnClicked: true } });
    userOrderStateDispatch({
      type: SCHEDULE_ORDER_DATA,
      value: {
        showScheduleOrderCatering: false,
        selectedStoreInfo,
      },
    });
    userOrderStateDispatch({
      type: DISPOSITION_METHOD,
      value: { dispositionType: selectedDispositionValue },
    });

    localStorage.setItem(DISPOSITION_TYPE, selectedDispositionValue);
    localStorage.setItem(STORE_INFO, JSON.stringify(selectedStoreInfo));
    localStorage.setItem(CURRENT_STORE_INFO_STORAGE, JSON.stringify(selectedStoreInfo));
    userOrderStateDispatch({
      type: CURRENT_STORE_INFO,
      value: selectedStoreInfo || {},
    });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    userOrderStateDispatch({
      type: MENU_PDP_PAGE_CONSTANTS.SET_MULTI_PRODUCT_VIEW_MODAL,
      isFromMultiProductViewModal: false,
    });
    const obj = await createBasketData(
      selectedStoreInfo,
      getDispositionTypeOnAPIFormat(selectedDispositionValue),
      '',
      dateTimeObj,
      scheduleOrderData?.deliveryAddress,
      scheduleOrderData?.deliveryAddressLine,
    );

    const getDispatchCreateBasketsAction = () => {
      dispatch(createBasketsAction({ data: obj, tenantId: tenantId }));
      setDispositionInfo(selectedDispositionValue, dateTimeObj, obj, basketId);
    };
    if (isCartNeedToCleared) {
      if (isCateringDisposition(currentStoreInfoData?.service)) {
        clearcartItem(selectedDispositionValue, dateTimeObj, obj);
        return;
      }
      if (
        (dispositionNew?.type?.toUpperCase() !== selectedDispositionValue ||
          dispositionNew?.store?.id !== currentStoreInfoData?.id ||
          dispositionNew?.deliveryAddress !== scheduleOrderData?.deliveryAddress ||
          dispositionNew?.selectedTime !== dateTimeObj.selectedTime ||
          dispositionNew?.date !== dateTimeObj?.date) &&
        basketId &&
        foodLines?.length
      ) {
        clearcartItem(selectedDispositionValue, dateTimeObj, obj);
        return;
      }
    }
    if (
      recursiveOrCheck(
        dispositionNew === null,
        dispositionNew?.type?.toUpperCase() !== selectedDispositionValue,
        dispositionNew?.store?.id !== currentStoreInfoData?.id,
        dispositionNew?.deliveryAddress !== scheduleOrderData?.deliveryAddress,
        dispositionNew?.deliveryAddressLine !== scheduleOrderData?.deliveryAddressLine,
        dispositionNew?.selectedTime !== dateTimeObj.selectedTime,
        dispositionNew?.date !== dateTimeObj?.date,
      )
    ) {
      if (basketId && foodLines?.length > 0) {
        if (
          dispositionNew?.type?.toUpperCase() !== selectedDispositionValue ||
          dispositionNew?.store?.id !== currentStoreInfoData?.id ||
          dispositionNew?.deliveryAddress !== scheduleOrderData?.deliveryAddress ||
          dispositionNew?.deliveryAddressLine !== scheduleOrderData?.deliveryAddressLine
        ) {
          dispatch(
            updateStoreWithDisposition(
              {
                tenantId,
                basketId,
                postBody: {
                  storeID: currentStoreInfoData?.id,
                  service: selectedDispositionValue?.toLowerCase(),
                  deliveryAddress: obj?.deliveryAddress,
                  requestedDateTime: obj?.requestedDateTime,
                },
              },
              () => {
                dispatch(
                  orderReadyDateTimeUpdate({
                    params: { basketId: basketId },
                    tenantId: tenantId,
                    postBody: obj?.requestedDateTime,
                  }),
                );
              },
            ),
          );
        }
        if (
          dispositionNew?.type?.toUpperCase() === selectedDispositionValue &&
          dispositionNew?.store?.id === currentStoreInfoData?.id &&
          dispositionNew?.deliveryAddress === scheduleOrderData?.deliveryAddress &&
          dispositionNew?.deliveryAddressLine === scheduleOrderData?.deliveryAddressLine &&
          (dispositionNew?.selectedTime !== dateTimeObj.selectedTime || dispositionNew?.date !== dateTimeObj?.date)
        ) {
          dispatch(
            orderReadyDateTimeUpdate({
              params: { basketId: basketId },
              tenantId: tenantId,
              postBody: obj?.requestedDateTime,
            }),
          );
        }
        setDispositionInfo(selectedDispositionValue, dateTimeObj, obj, '');
      } else {
        getDispatchCreateBasketsAction();
      }
    }
  };

  const editDeliveryLocation = useCallback(() => {
    userOrderStateDispatch({
      type: RESET_DELIVERY_ADDRESS_LINE,
    });
    onChangeLinkNavigation(FORM);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChangeLinkNavigation, userOrderStateDispatch]);

  const callStatusAPI = (storeList, serviceType, successCallBack) => {
    const dataList = createPayloadForStatusCall(storeList, serviceType, null, shouldCheckDropOffAddress);
    const statusCallPayload = {
      data: dataList,
      store: storeList,
      tenantId: tenantId,
      setStatusFlag: false,
      isFavoritePage: false,
    };
    dispatch(getBulkStoreStatus(statusCallPayload, successCallBack));
  };

  /**
   * Check if all time slots and selected time slot has order capacity available and display errors if not
   */
  useEffect(() => {
    if (enableOrderCapacityManagement && !isOrderCapacityLoading && !isEmpty(selectedDate?.date)) {
      const dateTimeFormatted = formatDateTime(selectedDate?.date?.key, DATE_FORMATS.YYYYMMDD);
      const orderCapacityForSelectedDate = orderCapacity?.[storeId]?.[dateTimeFormatted];
      if (orderCapacityForSelectedDate) {
        const timeSlotsOrderCapacities = Object.values(orderCapacityForSelectedDate);
        const isAllOrderCapacitiesEmpty = timeSlotsOrderCapacities.every(
          timeSlot => timeSlot === timeSlotsOrderCapacities[0] && Number(timeSlot) === 0,
        );
        if (isAllOrderCapacitiesEmpty) {
          scheduledOrderCapacityNoOrdersError(setHasError, hasError, true);
          setSelectedTime('');
        }
      }
      if (changeFlow && !isEmpty(selectedTime)) {
        const selectedTimeSlot = getFormatFromUnix(selectedTime?.key, DATE_FORMATS.HHmm);
        const selectedTimeSlotOrderCapacity =
          orderCapacityForSelectedDate &&
          Object.keys(orderCapacityForSelectedDate) &&
          Object.keys(orderCapacityForSelectedDate).includes(selectedTimeSlot)
            ? orderCapacityForSelectedDate[selectedTimeSlot]
            : null;

        if (Number(selectedTimeSlotOrderCapacity) === 0) {
          scheduledOrderCapacityTimeSlotError(setHasError, hasError, true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    changeFlow,
    enableOrderCapacityManagement,
    isOrderCapacityLoading,
    selectedDate?.date,
    selectedTime?.key,
    storeId,
  ]);

  const onConfirmHandler = event => {
    const isASAP = Boolean(selectedTime?.key === ASAP);
    changeOrderAnalyticsHandler(scheduleOrderData);
    // Check if selectedTime is less than current time
    if (scheduleTimeErrorFlag(selectedTime, enableScheduleOrderFlag)) {
      scheduledTimeError(setHasError, hasError, true);
    } else {
      const scheduledDateInEpoch = getScheduledEpochDateTime(isASAP, selectedTime);
      setShouldShowDateTimeSection(false);
      sessionStorage.setItem(SESSION_STORAGE_KEYS.SCHEDULE_DATE_EPOCH, scheduledDateInEpoch);
      if (enableScheduleOrderFlag && showOrderNow && orderNowFlag) {
        userOrderStateDispatch({ type: SET_ASAP_SCHEDULING, value: { enableASAPScheduling: true } });
      }
      if (enableScheduleOrderFlag && !(showOrderNow && orderNowFlag)) {
        userOrderStateDispatch({ type: SET_ASAP_SCHEDULING, value: { enableASAPScheduling: false } });
      }
      if (enableScheduleOrderFlag && changeScheduleOrderMode && showSheduleDisposition) {
        userOrderStateDispatch({
          type: START_ORDER_CONSTANTS.SET_ORDER_NOW,
          value: { showOrderNow: orderNowFlag },
        });
        userOrderStateDispatch({
          type: START_ORDER_CONSTANTS.SET_SCHEDULE_ORDER,
          value: { showScheduleOrder: scheduleOrderFlag },
        });
        userOrderStateDispatch({ type: CHANGE_SCHEDULE_MODE, value: { changeScheduleModeFlag: true } });
        userOrderStateDispatch({ type: SHOW_SCHEDULE_DISPOSITION, value: { showSheduleDisposition: true } });
      }
      const disbaleScheduleWarning = getDisableWarning(enableScheduleOrderFlag, showScheduleOrder);
      callStatusAPI(
        getTernaryValue(changeFlow, [dispositionNew?.store], [currentStoreInfoData]),
        getDispositionTypeOnAPIFormat(getDispositionObj(changeFlow, isAddressFlow, dispositionType)?.dispositionValue),
        response => {
          // TODO: Update with real data when christmas ordering item catalog is available, hard coded for now
          if (isSpecialEvent) {
            const localData = ParseJsonSafely(localStorage.getItem(CURRENT_STORE_INFO_STORAGE));
            const data = [
              {
                ...localData,
                id: localData.storeID,
                addresses: [
                  {
                    address: {
                      addressLines: ['485 George St, Cnr Bathurst St.'],
                      city: 'sydney',
                      country: 'Australia',
                      pinCode: '2000',
                      state: 'NSW',
                    },
                    lang: 'en-US',
                  },
                ],
              },
            ];
            getBasket(event, data, disbaleScheduleWarning, createBasket);
          } else {
            getBasket(event, response, disbaleScheduleWarning, createBasket);
          }
        },
      );
    }
  };

  const changeDateObj = {
    dispositionType,
    orderCapacityDataUpdated: ORDER_CAPACITY_DATA_UPDATED,
    setOrderCapacityCallDispatched,
    setSelectedDate,
    userOrderStateDispatch,
  };
  const changeTimeObj = {
    setSelectedTime,
    setErrorObj,
  };
  useEffect(() => {
    callStatusAPI(
      getTernaryValue(changeFlow, [dispositionNew?.store], [currentStoreInfoData]),
      getDispositionTypeOnAPIFormat(getDispositionObj(changeFlow, isAddressFlow, dispositionType)?.dispositionValue),
    );
    return () => {
      window.location.pathname !== ROUTE_URL.FIND_STORE &&
        userOrderStateDispatch({ type: SET_FIND_A_KFC_VIEW, value: { findAKFC: false } });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setScheduleDataOnChangeFlow(changeFlow, userOrderStateDispatch, dispositionNew, SCHEDULE_ORDER_DATA);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeFlow]);
  const isAsapSelecetedUnavailableFlag = isAsapSelecetedUnavailable(selectedStoreStatus, isAsapOrderFlag, selectedTime);
  const isFutureTimeSelectedUnavailableFlag = isFutureTimeSelectedUnavailable(
    isFutureTimeDateOrder,
    selectedDate,
    selectedTime,
    enableOrderCapacityManagement,
  );
  const isCompletelyClosed = isStoreCompletelyClosed({
    enableScheduleOrderFlag,
    isAsapSelecetedUnavailableFlag,
    isFutureTimeSelectedUnavailableFlag,
    isStoreStatusLoading,
    selectedStoreStatus,
    currentStoreInfoData,
  });
  const storeUnavailableError = getTernaryValue(isCompletelyClosed, orderModeScreenErrorText, '');

  useEffect(() => {
    const dispositionSelected = getDispositionObj(changeFlow, isAddressFlow, dispositionType)?.dispositionName;
    if (!storeUnavailableAnalyticFlag) {
      getStoreUnavailableErrorAnalytic(storeUnavailableError, dispositionSelected, setStoreUnavailableAnalyticFlag);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeUnavailableError, selectedStoreStatus?.currentStatus]);
  /**
   * Call order capacity on page load and once we have a success response, ensure it is not called again
   */
  useEffect(() => {
    if (
      enableOrderCapacityManagement &&
      !userOrderState?.orderCapacityDataUpdated &&
      !isOrderCapacityLoading &&
      !isEmpty(selectedDate?.date) &&
      !orderCapacityActionError
    ) {
      const dateTimeEpoch = getEpochTime(selectedDate?.date?.key, orderServDateFormat);
      if (dateTimeEpoch && !orderCapacityCallDispatched) {
        dispatch(
          getStoreOrderCapacityAction({
            storeId,
            dateTimeEpoch,
          }),
        );
        setOrderCapacityCallDispatched(true);
      }
    }
  }, [
    changeFlow,
    dispatch,
    enableOrderCapacityManagement,
    isOrderCapacityLoading,
    isOrderCapacitySuccess,
    isOrderCapacityFailure,
    orderCapacityActionError,
    orderCapacityCallDispatched,
    ORDER_CAPACITY_DATA_UPDATED,
    orderServDateFormat,
    selectedDate?.date,
    storeId,
    userOrderState?.orderCapacityDataUpdated,
    userOrderStateDispatch,
  ]);

  /** Set the orderCapacityDataUpdated flag to true once we have a success response from order capacity call, or
   *  set the orderCapacityActionError flag to true if we have a failure response from order capacity call
   */
  useEffect(() => {
    if (orderCapacityCallDispatched) {
      if (isOrderCapacitySuccess) {
        userOrderStateDispatch({ type: ORDER_CAPACITY_DATA_UPDATED, value: { orderCapacityDataUpdated: true } });
      }
      setOrderCapacityActionError(isOrderCapacityFailure);
    }
  }, [
    orderCapacityCallDispatched,
    isOrderCapacitySuccess,
    isOrderCapacityFailure,
    userOrderStateDispatch,
    ORDER_CAPACITY_DATA_UPDATED,
  ]);

  /**
   * ensure order capacity is fresh when changing date/time.
   */
  useEffect(() => {
    if (changeFlow) {
      userOrderStateDispatch({ type: ORDER_CAPACITY_DATA_UPDATED, value: { orderCapacityDataUpdated: false } });
    }
  }, [changeFlow, userOrderStateDispatch, ORDER_CAPACITY_DATA_UPDATED]);

  useEffect(() => {
    if (enableOrderCapacityManagement && hasError?.error) {
      setShouldShowDateTimeSection(true);
    }
  }, [hasError?.error, enableOrderCapacityManagement]);

  useEffect(() => {
    const store = getTernaryValue(storesWithStatus?.length > 0, storesWithStatus, [displayStoreInfo]);
    const shouldShowScheduleOrder = enableScheduleOrderFlag || shouldShowDateTime;
    const dateTimeManupulationObj = {
      shouldShowScheduleOrder,
      store,
      setDateTimeArr,
      setSelectedDate,
      setSelectedTime,
      changeFlow,
      showScheduleOrder,
      enableScheduleOrder: enableScheduleOrderFlag,
      enableClickCollectScheduleOrderFlag,
      scheduleModeClicked,
      orderServDateFormat,
      isSpecialEvent,
      enableOrderCapacityManagement,
    };
    if (enableOrderCapacityManagement) {
      if (isEmpty(selectedDate?.date)) {
        dateTimeManipulation(dateTimeManupulationObj);
      } else if (userOrderState?.orderCapacityDataUpdated) {
        const dateTimeFormatted = formatDateTime(selectedDate?.date?.key, DATE_FORMATS.YYYYMMDD);
        if (dateTimeFormatted && !isEmpty(orderCapacity?.[storeId]?.[dateTimeFormatted])) {
          dateTimeManupulationObj.selectedDate = selectedDate;
          dateTimeManipulation(dateTimeManupulationObj);
        }
      }
    } else {
      dateTimeManipulation(dateTimeManupulationObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storesWithStatus, changeFlow, displayStoreInfo, orderCapacity, userOrderState?.orderCapacityDataUpdated]);

  const selectedTimeText =
    translateWithI18Next(
      getDispositionObj(changeFlow, isAddressFlow, dispositionType)?.dispositionValue?.toLowerCase(),
    ) === translateWithI18Next(TRANSLATE_MAPPING_KEY.DELIVERY)
      ? translateWithI18Next(TRANSLATE_MAPPING_KEY.SELECT_DELIVERY_TIME)
      : translateWithI18Next(TRANSLATE_MAPPING_KEY.SELECT_PICKUP_TIME);
  const placeholderContent = placeholderContentText(
    currentStoreInfoData,
    changeScheduleMode && !isSpecialEvent,
    selectedTimeText,
  );
  const orderTypeSubSectionValue = isSpecialEvent
    ? translateWithI18Next(TRANSLATE_MAPPING_KEY.CHRISTMAS_ORDERING)
    : translateWithI18Next(
        getDispositionObj(changeFlow, isAddressFlow, dispositionType)?.dispositionValue?.toLowerCase(),
      );
  return (
    <React.Fragment>
      <ModalComponent
        id='ScheduleOrderModal'
        role='dialog'
        ariaLabel='Close Start your Order dialog'
        modalTitleId={'schedule-order-id'}
        show={true}
        classNames='search-store-modal extra-small-modal'
        showCloseBtn={true}
        closeButtonHandler={handleClose}
        modalTitle={translateWithI18Next(scheduleOrderScreenTitle)}
        closeDataTestId='close-modal-handler'
        backDataTestId='back-handler-schedule-order'
        showBackBtn={true}
        backButtonHandler={handleGoBack}
      >
        {/* Displays Order Type and change link */}
        <ScheduleOrderFormSection
          show={shouldShowOrderType}
          sectionHeader={ORDER_TYPE}
          subSectionValue={orderTypeSubSectionValue}
          orderTypeChange={ORDER_TYPE_CHANGE}
          onClickHandler={onChangeDisposition}
          storeUnavailableError={storeUnavailableError && !isSpecialEvent}
          enableScheduleOrder={enableScheduleOrder || isSpecialEvent}
          showOrderNow={showOrderNow}
        />
        {/* Displays User entered Location and change link */}
        <ScheduleOrderFormSection
          show={shouldShowUserLocation}
          sectionHeader={YOUR_LOCATION}
          subSectionValue={getUserAddress}
          description={checkDeliveryAddressLine}
          specialNote={checkSpecialNote}
          cssSubsection={isFromDeliveryAddressForm ? 'schedule-order-description-value' : ''}
          orderTypeChange={ORDER_TYPE_CHANGE}
          onClickHandler={editDeliveryLocation}
        />
        {/* Displays Selected KFC Location and change link */}
        <ScheduleOrderFormSection
          show
          sectionHeader={YOUR_KFC_RESTAURANT}
          subSectionValue={storeName}
          orderTypeChange={ORDER_TYPE_CHANGE}
          onClickHandler={handleGoBack}
          showChangeButton={showChangeCTAForDelivery(
            disableChangeCTAForDelivery,
            dispositionType,
            isFromDeliveryAddressForm,
          )}
        />
        {/* Displays Selected Delivery/Pickup Time */}
        <ScheduleOrderFormSection
          show={
            !isSpecialEvent && !isFromDeliveryAddressForm && enableScheduleOrderFlag ? showOrderNow && !isForNow : false
          }
          sectionHeader={
            getDispositionObj(changeFlow, isAddressFlow, dispositionType)?.dispositionValue?.toUpperCase() === DELIVERY
              ? DELIVERY_TIME
              : PICK_UP_TIME
          }
          subSectionValue={translateWithI18Next(TRANSLATE_MAPPING_KEY.ASAP)}
          orderTypeChange={ORDER_TYPE_CHANGE}
          onClickHandler={() =>
            enableScheduleMode(
              setOrderNowFlag,
              setScheduleOrdeFlag,
              setScheduleDisposition,
              setChangeScheduleOrderMode,
              null,
            )
          }
          showChangeButton={enableSceduleCA}
        />
        {getOrderType({
          userOrderState,
          enableScheduleOrderFlag,
          showScheduleOrder,
          showSheduleDisposition,
          shouldShowDateTime,
          dateString,
          enableSceduleCA,
          setOrderNowFlag,
          setScheduleOrdeFlag,
          setScheduleDisposition,
          setChangeScheduleOrderMode,
          isForNow,
          shouldShowDateTimeSection,
          isSpecialEvent,
          isFromDeliveryAddressForm,
        })}
        {}
        {/* Displays Form to Select Delivery/Pickup Time */}
        <DateTimeSection
          show={
            shouldShowDateTimeSection ||
            checkDateandTime({
              enableScheduleOrderFlag,
              showScheduleOrder,
              scheduleOrderFlag,
              showSheduleDisposition,
              shouldShowDateTime,
            })
          }
          sectionHeader={
            enableScheduleOrderFlag
              ? (getDispositionObj(changeFlow, isAddressFlow, dispositionType)?.dispositionValue?.toUpperCase() ===
                  DELIVERY &&
                  DELIVERY_TIME) ||
                PICK_UP_TIME
              : SCHEDULE_FOR_YOUR_ORDER_TEXT
          }
          subSectionValue={storeName}
          orderTypeChange={ORDER_TYPE_CHANGE}
          changeDateValue={changeDateValue}
          changeTimeValue={changeTimeValue}
          dateTimeArr={dateTimeArr}
          changeTimeObj={changeTimeObj}
          changeDateObj={changeDateObj}
          selectedDate={selectedDate}
          selectedTime={selectedTime}
          placeholderText={placeholderContent}
          enableClickCollectScheduleOrderFlag={enableClickCollectScheduleOrderFlag}
          showCateringWarning={{
            show: getAndCheck(
              dispositionType?.toUpperCase() === CATERING,
              userOrderState?.dispositionOld?.type?.toUpperCase() === DELIVERY,
            ),
            warning: translateWithI18Next(CATERING_WARNING),
            image: Error_Yellow,
            cssClass: 'location-blocked',
          }}
          scheduleTimeWarning={enableScheduleOrderFlag && hasError && hasError.error}
          scheduleErrMsg={hasError.errormessage}
          scheduleErrorType={hasError.errorType}
          scheduleWarningMsg={hasError.warningMessage}
          disableDateOption={disableDateOptionFlag}
          disableTimeOption={disableTimeOptionFlag}
          enableScheduleOrderFlag={enableScheduleOrderFlag}
          enableOrderCapacityManagement={enableOrderCapacityManagement}
          orderCapacity={orderCapacity}
          storeId={storeId}
        />
        {!enableScheduleOrderFlag && inlineMessage && (
          <div className='store-cannot-deliver-error timebased-inline-message'>
            <ImageComponent srcFile={IMAGE_PATH.Error_Yellow} className='store-cannot-deliver-icon' />
            <div className='storeErrorMessage'>{inlineMessage}</div>
          </div>
        )}
        <div className='scheduleOrder-button-container'>
          <ContainedButton
            variant={ButtonType.secondary}
            aria-label={translateWithI18Next(orderModeBtnText)}
            onClickHandler={onConfirmHandler}
            data-testid='confirm-button-handler'
            inactive={inactivateStartOrderButton({
              storeUnavailableError,
              enableScheduleOrderFlag,
              selectedTime,
              showOrderNow,
              changeScheduleMode,
              hasError,
              isForNow,
              scheduleModeClicked,
            })}
          >
            {translateWithI18Next(orderModeBtnText)}
          </ContainedButton>
        </div>
      </ModalComponent>
    </React.Fragment>
  );
};
export default ScheduleOrderContainer;
